// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__03Q9JarX","error":"Captcha_error__wngWg60I"};